import "./IconFlag.scss";

export const IconFlag = () => {
  return <span className="icon-flag"></span>;
};
